import React from "react";
import { cn } from "@/lib/utils";
import { BaseEntity } from "../../UniversalCRMTable/types/shared";
import { GroupItemsProps } from "../types";
import { EntityListRow } from "./EntityListRow";

/**
 * Renders the dense list rows within a group section. Each item is the generic
 * config-driven `EntityListRow` (or the caller's custom `renderItem`), so rows
 * inside a group look identical to the flat list.
 */
export function GroupItems<T extends BaseEntity>({
  items,
  isPrimary,
  isSecondary,
  rowContext,
}: GroupItemsProps<T>) {
  const { config, hooks, fieldLayout, rightFieldIds, onOpen, indexOfId, renderItem } = rowContext;

  return (
    <div
      className={cn(
        "divide-y",
        isPrimary && "divide-border/60",
        isSecondary && "divide-blue-100 dark:divide-blue-900/40"
      )}
    >
      {items.map((item) => {
        if (renderItem) {
          return <React.Fragment key={item.id}>{renderItem(item)}</React.Fragment>;
        }
        return (
          <EntityListRow<T>
            key={item.id}
            item={item}
            index={indexOfId(item.id)}
            config={config}
            hooks={hooks}
            fieldLayout={fieldLayout}
            rightFieldIds={rightFieldIds}
            onOpen={onOpen}
          />
        );
      })}
    </div>
  );
}

// Made with Bob
